export default [{
    'id': 'Organization-1',
    'name': 'Station 1',
    'type': '地铁站点',
    'lng': 118.0426776265562,
    'lat': 24.615059980612692,
    'height': 22.136707955493616,
}, {
    'id': 'Organization-2',
    'name': 'Station 2',
    'type': '地铁站点',
    'lng': 118.04337251571522,
    'lat': 24.616362782895056,
    'height': 15.526666700218673
}, {
    'id': 'Organization-3',
    'name': 'Gymnasium',
    'type': '体育馆',
    'lng': 118.0370266345929,
    'lat': 24.61922451555692,
    'height': 34.66786930566543
}, {
    'id': 'Organization-4',
    'name': 'Court',
    'type': '篮球场',
    'lng': 118.03667445472338,
    'lat': 24.618932090218,
    'height': 41.7557923475054
}, {
    'id': 'Organization-5',
    'name': 'Court',
    'type': '篮球场',
    'lng': 118.04402865928928,
    'lat': 24.614503342205197,
    'height': 41.552282540560405
}, {
    'id': 'Organization-6',
    'name': 'Court',
    'type': '篮球场',
    'lng': 118.04183532324004,
    'lat': 24.613487421899748,
    'height': 41.42472788391568
}, {
    'id': 'Organization-7',
    'name': 'Ping An Bank',
    'type': '银行',
    'lng': 118.04236489291199,
    'lat': 24.613679717089127,
    'height': 28.418341912823333
}, {
    'id': 'Organization-8',
    'name': 'ICBC',
    'type': '银行',
    'lng': 118.04031246784562,
    'lat': 24.61673560167116,
    'height': 21.82834818060487
}, {
    'id': 'Organization-9',
    'name': 'CMB',
    'type': '银行',
    'lng': 118.04020736580797,
    'lat': 24.61711031012507,
    'height': 22.049904719792554
}, {
    'id': 'Organization-10',
    'name': 'Ping An Bank',
    'type': '银行',
    'lng': 118.03992314656374,
    'lat': 24.61743038590008,
    'height': 22.414453247805028
}, {
    'id': 'Organization-11',
    'name': 'Pizza',
    'type': '餐饮',
    'lng': 118.04245736507063,
    'lat': 24.61400023453214,
    'height': 18.810997120486494
}, {
    'id': 'Organization-12',
    'name': 'Pig Feet Rice',
    'type': '餐饮',
    'lng': 118.04364525965424,
    'lat': 24.61426100382218,
    'height': 17.21526845961332
}, {
    'id': 'Organization-13',
    'name': 'KFC',
    'type': '餐饮',
    'lng': 118.0402739166898,
    'lat': 24.619339290723985,
    'height': 19.603622967144037
}, {
    'id': 'Organization-14',
    'name': 'McDonald',
    'type': '餐饮',
    'lng': 118.0387800995963,
    'lat': 24.618384321878167,
    'height': 24.0705099990404
}, {
    'id': 'Organization-15',
    'name': 'Herbal soup',
    'type': '餐饮',
    'lng': 118.03810547473377,
    'lat': 24.617903990882724,
    'height': 25.016742435762616
}, {
    'id': 'Organization-16',
    'name': 'Lasagna',
    'type': '餐饮',
    'lng': 118.03947795115641,
    'lat': 24.61730505802264,
    'height': 40.273324646655944
}, {
    'id': 'Organization-17',
    'name': 'Station 4',
    'type': '公交站点',
    'lng': 118.04415165535814,
    'lat': 24.6152799685196,
    'height': 16.01784083874208
}, {
    'id': 'Organization-18',
    'name': 'Street Station',
    'type': '公交站点',
    'lng': 118.04188369055025,
    'lat': 24.61589249451894,
    'height': 20.66279242601635
}, {
    'id': 'Organization-19',
    'name': 'Station 4',
    'type': '公交站点',
    'lng': 118.03813222605935,
    'lat': 24.619093728393118,
    'height': 20.42350823360823
}];